import styled, { css } from 'styled-components';
import { colors, smallShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { QuickNav } from 'modules/quickNav';

import { WF_Z_INDEX } from '../../constants';

const HEADER_BAR_HEIGHT = spacing.x4;

const WorkflowControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const HeaderControlsLeft = styled(WorkflowControls)``;

export const HeaderControlsRight = styled(WorkflowControls)`
  flex-shrink: 0;
  margin-left: auto;

  align-items: center;
`;

export const HeaderBarWrapper = styled.div`
  flex: 0 0 auto;
  position: relative;
  /** so that dropdowns are viewable over the main part of the page */
  z-index: ${WF_Z_INDEX.HEADER};
  button::selection {
    color: inherit;
    background-color: transparent;
  }
`;

type HeaderBarProps = {
  $isPublished?: boolean;
};

const PUBLISHED_HEADER_STYLES = css`
  background-color: ${colors.white};
`;

export const HeaderBarContainer = styled.div<HeaderBarProps>`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 0 ${spacing.half};
  gap: ${spacing.half};
  height: ${HEADER_BAR_HEIGHT};
  background-color: ${colors.purple100};
  box-shadow: ${smallShadow.boxShadow};

  ${({ $isPublished }) => $isPublished && PUBLISHED_HEADER_STYLES};
`;

export const HamburgerContainer = styled.div`
  display: flex;
  align-items: center;

  user-select: none;

  :hover {
    cursor: pointer;
  }

  margin-left: ${spacing.base};
`;

export const HeaderIconButton = styled.div`
  height: ${pxToRem(36)};
  width: ${pxToRem(42)};
`;

export const StyledQuickNav = styled(QuickNav)`
  /** Remove HeaderBar height from QuickNav so it doesn't overflow */
  max-height: calc(100vh - ${HEADER_BAR_HEIGHT});
`;
